import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from '@eliadmin/core/src/components/ui/sheet';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { MdOutlineMoreHoriz } from 'react-icons/md';
import { TourSidebarFilterContent } from './tour-sidebar-filter-content';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiX } from 'react-icons/fi';

export const TourSidebarFilterTrigger = () => {
  const { t } = useTranslations();

  return (
    <Sheet>
      <SheetTrigger>
        <div className="hidden h-[30px] items-center gap-1 whitespace-nowrap rounded-[8px] bg-white px-3 text-sm sm:flex sm:h-[33px]">
          <MdOutlineMoreHoriz className="h-4 w-4 text-gray-700" />
          {t('text1848')}
        </div>
        <div className="flex h-[30px] items-center gap-1 whitespace-nowrap rounded-[8px] bg-white px-3 text-sm sm:hidden sm:h-[33px]">
          <MdOutlineMoreHoriz className="h-4 w-4 text-gray-700" />
          {t('text1858')}
        </div>
      </SheetTrigger>
      <SheetContent
        side={'right'}
        className="hide-scroll-bar right-0 z-[5000] h-[100vh] w-[100vw] max-w-[100vw] overflow-y-scroll pb-[160px] pr-6 sm:w-[440px] sm:min-w-[440px] md:min-w-[600px]"
        showCloseIcon={false}
      >
        <TourSidebarFilterContent />
        <SheetClose
          className={cn(
            'fixed z-30 flex items-center gap-1 rounded-sm text-sm text-primary opacity-100 ring-offset-background transition-opacity disabled:pointer-events-none data-[state=open]:bg-secondary',
            'right-4 top-10 ',
          )}
        >
          <FiX className={cn('h-[18px] w-[18px]')} />
          <span>{t('text1855').toUpperCase()}</span>
        </SheetClose>
      </SheetContent>
    </Sheet>
  );
};
